"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)("path", {
    d: "M371.8,194.6l-260.6-86.9c-9.9-3.3-19.3,6.1-16,16L182,384.3c3,8.9,14.3,11.6,21,5l51-51l70.1,70.1c4.9,4.9,13,4.9,17.9,0l53.8-53.8c4.9-4.9,4.9-13,0-17.9l-70.1-70.1l51-51C383.4,208.9,380.7,197.6,371.8,194.6z"
  });
};

exports.default = _default;